import { ACCOUNT_VERIFIED_ROUTE, CAPTURE_MAP_ROUTE, CAPTURE_PROFILE_ROUTE, VERIFICATION_ROUTE } from 'constants/routes';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { OnBoardingState } from 'types/onboarding';
import OnboardingHeader from '../OnboardingHeader';
import { OnboardingHeaderProps } from '../OnboardingHeader/types';
import Styled from '../Styled';
import TopErrorBanner from '../TopErrorBanner';
import { BottomLeftVector, BottomRightVector, Content, ContentWrapper, TopLeftVector } from './OnboardingPageWrapper.style';

interface Props extends OnboardingHeaderProps {
    showTopLeftVector?: boolean;
    showBottomLeftVector?: boolean;
    showBottomRightVector?: boolean;
    showTopErrorBanner?: boolean;
    children: React.ReactNode;
}

export const OnboardingPageWrapper = ({
    showLogoutButton,
    showBackButton,
    onGoBack,
    children,
    progress,
    showBottomLeftVector = false,
    showBottomRightVector = false,
    showTopLeftVector = false,
    showTopErrorBanner = true
}: Props) => {
    const topLeftVector = showTopLeftVector ? <TopLeftVector /> : null;
    const bottomLeftVector = showBottomLeftVector ? <BottomLeftVector /> : null;
    const bottomRightVector = showBottomRightVector ? <BottomRightVector /> : null;
    const onboardingRoutes = [ACCOUNT_VERIFIED_ROUTE, VERIFICATION_ROUTE, CAPTURE_PROFILE_ROUTE, CAPTURE_MAP_ROUTE];
    const location = useLocation();
    const locationState = location.state as OnBoardingState;
    //eslint-disable-next-line
    const continuousFlow = onboardingRoutes.includes(location.pathname) ? locationState?.continue : true;

    return (
        <Styled.FlexBox style={{ width: '100%', minHeight: '100vh', overflowX: 'hidden', zIndex: 1 }} direction="column">
            <OnboardingHeader showBackButton={showBackButton} onGoBack={onGoBack} showLogoutButton={showLogoutButton} progress={progress} />
            {continuousFlow || !showTopErrorBanner || locationState?.onboarding ? null : <TopErrorBanner />}
            <Content>
                <ContentWrapper hasBottomVector={!!showBottomLeftVector}>
                    {topLeftVector}
                    {children}
                    {bottomLeftVector}
                    {bottomRightVector}
                </ContentWrapper>
            </Content>
        </Styled.FlexBox>
    );
};
